import { uniq } from "es-toolkit";
import { SOURCE_HIGHLIGHT_LAYER_ID } from "../constants/layer.js";
const SOURCE_LAYER_DEFAULT_COLOR = "#564A4A";
const SOURCE_LAYER_SELECTED_COLOR = "#829460";
const SOURCE_LAYER_LAYER_DEFAULT_COLOR = "#F96666";
const OUTLINE_COLOR = "#282C35";
const DEFAULT_OPACITY = 0.7;
function createLayerId(...args) {
    return `${SOURCE_HIGHLIGHT_LAYER_ID}-${args.join("-")}`;
}
function createRasterLayers(source) {
    const { sourceId, } = source;
    return [{
            id: createLayerId(sourceId),
            type: "raster",
            source: sourceId,
            layout: {
                visibility: "visible",
            },
        }];
}
function geometriesToLayerType(geometry) {
    const parts = (Array.isArray(geometry) ? geometry : [geometry])
        .flatMap(g => g.split(","));
    return uniq(parts.map((g) => {
        if (g === "LineString" || g === "MultiLineString") {
            return "line";
        }
        if (g === "Point" || g === "MultiPoint") {
            return "circle";
        }
        return "fill";
    }));
}
function getHighlightPaint(type, color) {
    if (type === "fill") {
        return {
            "fill-color": color,
            "fill-outline-color": OUTLINE_COLOR,
            "fill-opacity": DEFAULT_OPACITY,
        };
    }
    else if (type === "line") {
        return {
            "line-color": color,
            "line-width": 2,
            "line-opacity": DEFAULT_OPACITY,
        };
    }
    else if (type === "circle") {
        return {
            "circle-color": color,
            "circle-radius": 2,
            "circle-opacity": DEFAULT_OPACITY,
        };
    }
    return {};
}
function createVectorLayers(source, sourceLayerId, sourceLayerLayerId) {
    const { sourceId, layers, metadata: { vectorLayers, tilestats, }, } = source;
    const sourceHighlightLayers = vectorLayers.map((vectorLayer) => {
        const { id: layerId, } = vectorLayer;
        const layerStats = tilestats.layers.find(l => l.layer === layerId);
        if (!layerStats) {
            return [];
        }
        return geometriesToLayerType(layerStats.geometry).map((type) => {
            const color = sourceLayerId === layerId
                ? SOURCE_LAYER_SELECTED_COLOR
                : SOURCE_LAYER_DEFAULT_COLOR;
            return {
                "id": createLayerId(sourceId, layerId, type),
                "type": type,
                "source": sourceId,
                "source-layer": layerId,
                "paint": getHighlightPaint(type, color),
            };
        });
    });
    if (sourceLayerLayerId) {
        const layer = layers.find(l => l.id === sourceLayerLayerId);
        if (layer) {
            const { id, type, } = layer;
            const color = SOURCE_LAYER_LAYER_DEFAULT_COLOR;
            sourceHighlightLayers.push([{
                    ...layer,
                    type,
                    id: createLayerId(sourceId, id),
                    paint: getHighlightPaint(type, color),
                }]);
        }
    }
    return sourceHighlightLayers.flat();
}
function createGeoJSONLayers(source, sourceLayerLayerId) {
    const { sourceId, layers, metadata: { tilestats, }, } = source;
    const sourceHighlightLayers = tilestats.layers.flatMap((layerStats) => {
        return geometriesToLayerType(layerStats.geometry).map((type) => {
            return {
                id: createLayerId(sourceId, layerStats.layer, type),
                type,
                source: sourceId,
                paint: getHighlightPaint(type, SOURCE_LAYER_DEFAULT_COLOR),
            };
        });
    });
    if (sourceLayerLayerId) {
        const layer = layers.find(l => l.id === sourceLayerLayerId);
        if (layer) {
            const { id, type, } = layer;
            sourceHighlightLayers.push({
                ...layer,
                type,
                id: createLayerId(sourceId, id),
                paint: getHighlightPaint(type, SOURCE_LAYER_LAYER_DEFAULT_COLOR),
            });
        }
    }
    return sourceHighlightLayers;
}
export function createHighlightLayers(source, sourceLayerId, sourceLayerLayerId) {
    if (source.metadata) {
        if (source.metadata.meta_format === "raster") {
            return createRasterLayers(source);
        }
        if (source.metadata.meta_format === "geojson") {
            return createGeoJSONLayers(source, sourceLayerLayerId);
        }
        else {
            return createVectorLayers(source, sourceLayerId, sourceLayerLayerId);
        }
    }
    return [];
}
;
